import {
    MarkovStartvectorState,
    MarkovState,
} from "server/models"
import { inferLiteral, OrderType } from "client/utils"
import { MarkovStateFilters } from "client/store"
import * as types from "./types"


export const setMarkovStartvectorStateList = (stateList: types.MarkovStartvectorStateList) => ({
    type: inferLiteral(types.MARKOV_STARTVECTOR_STATE_LIST),
    stateList,
})
export const setMarkovStartvectorStateIds = (stateIds: readonly number[]) => ({
    type: inferLiteral(types.MARKOV_STARTVECTOR_STATE_IDS),
    stateIds,
})
export const setMarkovStartvectorStateEdit = (state: MarkovStartvectorState) => ({
    type: inferLiteral(types.MARKOV_STARTVECTOR_STATE_EDIT),
    state,
})
export const setMarkovStartvectorStateCalculatedExpressions = (calcualted: types.MarkovStartvectorStateCalculated) => ({
    type: inferLiteral(types.MARKOV_STARTVECTOR_STATE_CALCULATED_EXPRESSIONS),
    calcualted,
})
export const setMarkovStartvectorStateSort = (sortColumn: keyof MarkovState, sortOrder: OrderType) => ({
    type: inferLiteral(types.MARKOV_STARTVECTOR_STATE_SORT),
    sortColumn,
    sortOrder,
})
export const setMarkovStartvectorStateFilters = (filters: MarkovStateFilters) => ({
    type: inferLiteral(types.MARKOV_STARTVECTOR_STATE_FILTERS),
    filters,
})
export const setMarkovStartvectorStateReloadList = (value: boolean) => ({
    type: inferLiteral(types.MARKOV_STARTVECTOR_STATE_RELOAD_LIST),
    value,
})
export const setMarkovStartvectorStateReloadEdit = (value: boolean) => ({
    type: inferLiteral(types.MARKOV_STARTVECTOR_STATE_RELOAD_EDIT),
    value,
})
